import React from 'react';
import styles from './addBabyDragon.module.scss';
import qr from '../../../assets/images/QRcode.png'

const addBabyDragon = () => (
  <div className={styles.wrapper}>
    <div className={[styles.container].join(' ')}>
      <div className={[styles.babyDragonImageBlock].join(' ')}>
        <img src={qr} alt="龍寶寶QRcode" />
      </div>
      <div className={[styles.babyDragonTextBlock].join(' ')}>
        <h1>現在就把龍寶寶加入群組吧！</h1>
        <div className={styles.lineId}> LINE搜尋：@781zqjfw </div>
      </div>
      <p>龍寶寶沒有任何的盈利，如果你喜歡龍寶寶歡迎贊助我們喝一杯咖啡，也歡迎寫下你的建議及任何願望，在我們餓死之前都會樂意盡量實現。</p>
      <div className={[styles.bottonGroup].join(' ')}>
        <a href='https://lin.ee/52gLqtX' target="_blank">加入好友立即試用</a>
        <a href='https://line.me/ti/g2/JQSvruSRaGohfZZMfIkPvw?utm_source=invitation&utm_medium=link_copy&utm_campaign=default' target="_blank">加入 Line 社群</a>
        <a href='https://forms.gle/wtt7FU8M7KXjzFya8' target="_blank">寶寶信箱</a>
        <a href='https://www.buymeacoffee.com/longbaobao' target="_blank">我要贊助</a>
      </div>
    </div>
  </div>
)

export default addBabyDragon
